module.exports = {
    language: {
    　　name: '中文'
    },
    navbar: {
    　  home: 'Home',
        walkInto:'Into',
        coreBusiness:'Core',
        case:'Case',
        news:'News',
        link:'Link'
    },
    home:{
        companyNews:'Company news',
        industryNews:'Industry news',
        more:'More'

    }
}